<div class="admin-call-center-container">
  <h4>Support Call Center</h4>

  <nb-card class="availability-card">
    <nb-card-body>
      <div class="availability-toggle-row">
        <div class="toggle-label-group">
          <nb-icon icon="phone-call-outline" class="toggle-icon"></nb-icon>
          <span class="toggle-label">Available for Calls</span>
        </div>
        <nb-toggle [(checked)]="isAvailable" (checkedChange)="toggleAvailability()"></nb-toggle>
      </div>

      <p class="availability-status" [class.available]="isAvailable" [class.unavailable]="!isAvailable">
        <nb-icon [icon]="isAvailable ? 'checkmark-circle-2-outline' : 'close-circle-outline'"></nb-icon>
        {{ isAvailable ? 'You are visible to managers and will receive incoming calls.' : 'You are offline. Managers cannot call you.' }}
      </p>
    </nb-card-body>
  </nb-card>

  <div *ngIf="(callState$ | async) === 'connected'" class="active-call-banner">
    <nb-icon icon="phone-call-outline"></nb-icon>
    <span>Currently in a call</span>
    <button nbButton status="danger" size="small" (click)="callService.endCall()">End Call</button>
  </div>

  <div *ngIf="(callState$ | async) === 'ringing-in'" class="ringing-banner">
    <nb-icon icon="bell-outline"></nb-icon>
    <span>Incoming call...</span>
  </div>
</div>
